import {
  DocumentPdfRegular,
  DocumentRegular,
  DocumentTableRegular,
  DocumentTextRegular,
  SlideTextRegular,
} from '@/components/Icon'
import styles from './index.module.scss'
import { extensionFromName } from './attachmentMetaExtension.js'

export function AttachmentPreviewIcon({ file }) {
  const fileName = typeof file?.name === 'string' ? file.name : ''
  const ext = extensionFromName(fileName)
  const mime = typeof file?.type === 'string' ? file.type : ''

  if (mime === 'application/pdf' || ext === 'pdf') {
    return <DocumentPdfRegular className={styles.chipTypeIcon} />
  }
  if (
    mime.includes('spreadsheet') ||
    mime.includes('excel') ||
    ['xls', 'xlsx', 'csv', 'ods'].includes(ext)
  ) {
    return <DocumentTableRegular className={styles.chipTypeIcon} />
  }
  if (
    mime.includes('presentation') ||
    mime.includes('powerpoint') ||
    ['ppt', 'pptx', 'odp'].includes(ext)
  ) {
    return <SlideTextRegular className={styles.chipTypeIcon} />
  }
  if (
    mime.startsWith('text/') ||
    ['txt', 'md', 'json', 'xml', 'html', 'css', 'js', 'jsx', 'ts', 'tsx'].includes(ext)
  ) {
    return <DocumentTextRegular className={styles.chipTypeIcon} />
  }
  return <DocumentRegular className={styles.chipTypeIcon} />
}
